import {
  Grid,
  Box,
  Typography,
  Card,
  IconButton,
  CardActionArea,
  Divider,
  Avatar,
} from '@mui/material';
import { PropertyContext } from 'component/PropertyContext/PropertyContext';
import { useContext, useState } from 'react';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import Profile from 'assets/images/MarketPhoto.png';
import { poppins400, poppins600 } from 'theme/common.style';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { Msg, Phn, Calldownarrow } from './Marketplaceicons';
import ContactPopOver from 'component/ContactTab/ContactPopOver';
import { datacontext } from 'modules/AppLayout/AppLayout';
import { USER_TYPE } from 'constant/app.config';
import AgencyBadge from 'component/Common/AgencyBadge';

export const AgentComp = ({
  isStickyAddress,
  showActivateTrade,
  getBuyerIndividualValue,
  sharedpage,
  setOpenlogin,
  openlogin,
  directcomm,
  setIsHovered,
  isSticky,
  isHovered,
  handleMouseLeave,
  handleClick,
  isDialogOpen,
  setDialogOpen,
  anchorEl,
  matchessm,
  matchestable400,
  buyerIndividual,
  buyerDashboardAgentDetails,
  setAnchorEl,
}) => {
  const [showDetails, setSHowDetails] = useState(false);

  const { setIsBinderChatOpen } = useContext(PropertyContext);
  const { setShowMessage, setMessagedata } = useContext(datacontext);
  const history = useHistory();

  return (
    <>
      <Grid
        sx={{
          display: 'flex',
          flexDirection: 'row',
          minWidth: '100%',
          zIndex: 2,
        }}
      >
        <Card
          onClick={() => {
            if (matchessm) {
              setSHowDetails(!showDetails);
            }
          }}
          sx={{
            position: !matchessm && 'absolute',
            top: buyerIndividual ? 25 : 15,
            right: buyerIndividual ? '3%' : isStickyAddress ? '12%' : '6%',
            display: 'flex',
            alignItems: showDetails && matchessm ? 'start' : 'center',
            flexDirection: showDetails && matchessm ? 'column' : 'row',
            justifyContent: 'space-between',
            minWidth: !matchessm && '350px',
            height: showDetails ? '180px' : '66px',
            borderRadius: !matchessm && '33px 5px 5px 33px',
            padding: '8px',
            alignSelf: 'end',
            flex: 1,
            background: showDetails && matchessm ? 'white' : '#F7F8F7',
            zIndex: 7,
            boxShadow: 'none',
            gap: 2,
          }}
        >
          <Grid
            sx={{
              flexDirection: 'row',
              display: 'flex',
              gap: 2,
            }}
          >
            <Grid>
              {getBuyerIndividualValue?.PropertyDetails?.agentDetails
                ?.agentProfile == '' ||
              getBuyerIndividualValue?.PropertyDetails?.agentDetails
                ?.agentProfile == null ? (
                <Avatar
                  style={{
                    height: '56px',
                    width: '56px',
                    fontFamily: 'poppins',
                    backgroundColor: '#666666',
                  }}
                >
                  {getBuyerIndividualValue?.PropertyDetails?.agentDetails?.agentName
                    ?.charAt(0)
                    ?.toUpperCase() ||
                    buyerDashboardAgentDetails?.agentName
                      ?.charAt(0)
                      ?.toUpperCase()}
                  {getBuyerIndividualValue?.PropertyDetails?.agentDetails?.agentSurName
                    ?.charAt(0)
                    ?.toUpperCase() ||
                    buyerDashboardAgentDetails?.agentSurName
                      ?.charAt(0)
                      ?.toUpperCase()}
                </Avatar>
              ) : (
                <Avatar
                  src={
                    getBuyerIndividualValue?.PropertyDetails?.agentDetails
                      ?.agentProfile || buyerDashboardAgentDetails?.agentProfile
                  }
                  style={{ height: '56px', width: '56px' }}
                />
              )}
            </Grid>
            <Grid>
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                }}
              >
                <Box sx={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                  <Typography
                    sx={{
                      ...poppins600,
                      fontSize: '20px',
                      color: '#6C2AD2',
                      width: matchestable400 ? '100px' : 'auto',
                      whiteSpace: 'nowrap',
                      textOverflow: 'ellipsis',
                      overflow: 'hidden',
                    }}
                  >
                    {getBuyerIndividualValue?.PropertyDetails?.agentDetails
                      ?.agentName || buyerDashboardAgentDetails?.agentName}{' '}
                    {getBuyerIndividualValue?.PropertyDetails?.agentDetails
                      ?.agentSurName ||
                      buyerDashboardAgentDetails?.agentSurName}
                  </Typography>
                  {matchessm && (
                    <IconButton>
                      {!showDetails ? (
                        <KeyboardArrowDownIcon sx={{ fontSize: '20px' }} />
                      ) : (
                        <KeyboardArrowUpIcon sx={{ fontSize: '20px' }} />
                      )}
                    </IconButton>
                  )}
                </Box>
                <Typography
                  sx={{
                    ...poppins400,
                    fontSize: '14px',
                    color: '#666666',
                  }}
                >
                  Agent
                </Typography>
              </Box>
            </Grid>
          </Grid>
          <Grid
            sx={{
              display: matchessm && !showDetails ? 'none' : 'flex',
              flexDirection:
                showDetails && matchessm ? 'column-reverse' : 'row',
              justifyContent: 'end',
              gap: showDetails && matchessm && '15px',
              alignItems: showDetails && matchessm ? 'start' : 'center',
            }}
          >
            <Box
              sx={{ display: 'flex', alignItems: 'center', gap: '15px' }}
              onClick={(event) => {
                event.stopPropagation();
                if (sharedpage && (USER_TYPE === 'Buyer' || !USER_TYPE)) {
                  setOpenlogin(!openlogin);
                } else {
                  setIsBinderChatOpen(true);
                  directcomm(
                    getBuyerIndividualValue?.PropertyDetails?.agentDetails
                      ?.agentId || buyerDashboardAgentDetails?.agentId
                  );
                }
              }}
            >
              <CardActionArea
                sx={{
                  border: '1px solid rgba(0, 0, 0, 0.12)',
                  borderRadius: '5px',
                  padding: '8px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginRight: !showDetails && !matchessm && '10px',
                }}
              >
                <Msg />
              </CardActionArea>
              {showDetails && matchessm && (
                <Typography
                  sx={{
                    fontFamily: 'poppins',
                    color: '#666666',
                    fontSize: '14px',
                    whiteSpace: 'nowrap',
                  }}
                >
                  Message{' '}
                  {getBuyerIndividualValue?.PropertyDetails?.agentDetails
                    ?.agentName || buyerDashboardAgentDetails?.agentName}{' '}
                  {getBuyerIndividualValue?.PropertyDetails?.agentDetails
                    ?.agentSurName || buyerDashboardAgentDetails?.agentSurName}
                </Typography>
              )}
            </Box>

            <Box
              sx={{ display: 'flex', alignItems: 'center', gap: '15px' }}
              onClick={(event) => {
                event.stopPropagation();
                if (sharedpage && (USER_TYPE === 'Buyer' || !USER_TYPE)) {
                  setOpenlogin(!openlogin);
                } else {
                  // localStorage.setItem(
                  //   'dialId',
                  //   getBuyerIndividualValue?.PropertyDetails?.agentDetails
                  //     ?.agentEmail
                  // );
                  // setShowMessage(true);
                  // setMessagedata({ incomingcall: true });
                  return window.open(
                    `tel:${
                      getBuyerIndividualValue?.PropertyDetails?.agentDetails
                        ?.agentMobileNo ||
                      buyerDashboardAgentDetails?.agentMobileNo
                    }`
                  );
                }
              }}
            >
              <CardActionArea
                variant="rounded"
                sx={{
                  border: '1px solid rgba(0, 0, 0, 0.12)',
                  borderRadius: '5px',
                  padding: '8px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={handleMouseLeave}
              >
                <Phn />
              </CardActionArea>
              {showDetails && matchessm && (
                <Typography
                  sx={{
                    fontFamily: 'poppins',
                    color: '#666666',
                    fontSize: '14px',
                    whiteSpace: 'nowrap',
                  }}
                >
                  Call{' '}
                  {getBuyerIndividualValue?.PropertyDetails?.agentDetails
                    ?.agentName || buyerDashboardAgentDetails?.agentName}{' '}
                  {getBuyerIndividualValue?.PropertyDetails?.agentDetails
                    ?.agentSurName || buyerDashboardAgentDetails?.agentSurName}
                </Typography>
              )}
            </Box>
            {/* &nbsp;&nbsp; */}
            {/* {!matchessm && (
              <Grid
                sx={{
                  alignItems: 'center',
                  marginLeft: '10px',
                  marginTop: '3px',
                  cursor: 'pointer',
                }}
                onClick={handleClick}
              >
                {isHovered && (
                  <Calldownarrow
                    style={{ position: 'absolute', top: '-10px', left: '50%' }}
                  />
                )}
              </Grid>
            )}
            {!matchessm && (
              <ContactPopOver
                name={
                  getBuyerIndividualValue?.PropertyDetails?.agentDetails
                    ?.agentName
                }
                surname={
                  getBuyerIndividualValue?.PropertyDetails?.agentDetails
                    ?.agentSurName
                }
                emailid={
                  getBuyerIndividualValue?.PropertyDetails?.agentDetails
                    ?.agentEmail
                }
                mobilenum={
                  getBuyerIndividualValue?.PropertyDetails?.agentDetails
                    ?.agentMobileNo
                }
                isDialogOpen={isDialogOpen}
                setDialogOpen={setDialogOpen}
                anchorEl={anchorEl}
                setAnchorEl={setAnchorEl}
              />
            )} */}
          </Grid>
        </Card>
        {getBuyerIndividualValue?.agentAgencyName && (
          <AgencyBadge
            name={getBuyerIndividualValue.agentAgencyName}
            variant="individual"
            sx={{
              minWidth: matchessm ? '126px' : '160px',
              width: matchessm ? '126px' : 'auto',
              height: matchessm ? '68px' : '66px',
              position: !matchessm ? 'absolute' : undefined,
              right: !matchessm
                ? buyerIndividual
                  ? '3%'
                  : !isStickyAddress
                  ? '6%'
                  : '1%'
                : undefined,
              top: !matchessm
                ? buyerIndividual
                  ? 107
                  : !isSticky
                  ? 100
                  : 20
                : undefined,
            }}
            typographySx={{
              whiteSpace: matchessm ? 'normal' : 'nowrap',
              textAlign: matchessm || isStickyAddress ? 'center' : undefined,
            }}
          />
        )}
      </Grid>
      {showDetails && (
        <Box>
          <Divider
            sx={{
              width: '100%',
              borderColor: 'text.primary',
              display: { xs: 'block', md: 'none' },
            }}
          />
        </Box>
      )}
    </>
  );
};
